import React from 'react';
import { GraduationCap, Sparkles } from 'lucide-react';
import { MediaImage } from '@/components/ui/MediaImage';
import { BRAND_LOGO_URL, BRAND_NAME, BRAND_SHORT, BRAND_TAGLINE } from '@/config/branding';

/**
 * App logo + title for headers and login.
 */
export function BrandMark({ compact = false, showTagline = true }) {
  return (
    <div className="flex min-w-0 items-center gap-2 sm:gap-3">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-lg primary-gradient shadow-lg shadow-indigo-200 sm:h-10 sm:w-10 sm:rounded-xl">
        {BRAND_LOGO_URL ? (
          <MediaImage src={BRAND_LOGO_URL} alt="" className="h-full w-full object-cover" />
        ) : (
          <GraduationCap className="h-5 w-5 text-white sm:h-6 sm:w-6" />
        )}
      </div>
      <div className="min-w-0">
        <h1 className="flex min-w-0 items-center gap-1 text-sm font-black tracking-tight text-slate-900 sm:gap-2 sm:text-base md:text-xl">
          <span className="truncate">{compact ? BRAND_SHORT : BRAND_NAME}</span>
          <Sparkles className="h-3 w-3 shrink-0 fill-yellow-500 text-yellow-500 sm:h-4 sm:w-4" />
        </h1>
        {showTagline ? (
          <p className="hidden text-[9px] font-bold uppercase leading-none tracking-widest text-slate-400 sm:block sm:text-[10px]">
            {BRAND_TAGLINE}
          </p>
        ) : null}
      </div>
    </div>
  );
}
